import { CurbZoneMap } from "modules/curb-zone";
import { Wrapper } from "components/layout";

export function CurbZonePage() {
  return (
    <Wrapper title="Home Page" className="mask-background">
      <div className="relative -mt-16 map-height">
        <CurbZoneMap />
      </div>
    </Wrapper>
  );
}
